<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card max-width="600" grid-list-lg>
      <ModelTitle title="Refund Invoice" @close="close()" />

      <v-card-text>
        <v-container class="pa-0" grid-list-lg>
          <v-card-text>
            <v-layout v-if="Invoice" row wrap justify-space-between>
              <v-flex xs6 v-if="Invoice.Donor">
                <div>Donor ID</div>
                <div class="font-weight-medium title">
                  {{ Invoice.Donor.id }}
                </div>
              </v-flex>
              <v-flex xs6 v-else-if="Invoice.Customer">
                <div>Customer ID</div>
                <div class="font-weight-medium title">
                  {{ Invoice.Customer.localId }}
                </div>
              </v-flex>
              <v-flex shrink>
                <div>Total</div>
                <div class="font-weight-medium title">
                  {{ Invoice.total | currency }}
                </div>
              </v-flex>
              <v-flex xs8  v-if="Invoice.Donor">
                <div>Donor Name</div>
                <div class="font-weight-medium title text-capitalize">
                  {{ Invoice.Donor.name }}
                </div>
              </v-flex>
              <v-flex xs8  v-if="Invoice.Customer">
                <div>Customer Name</div>
                <div class="font-weight-medium title text-capitalize">
                  {{ Invoice.Customer.name }}
                </div>
              </v-flex>
              <v-flex shrink>
                <div>Payed</div>
                <div class="font-weight-medium title">
                  {{ Invoice.payment | currency }}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card outlined max-width="800">
            <v-stepper v-if="Invoice" vertical v-model="step" class="elevation-0">
              <v-stepper-step :complete="step > 1" step="1">
                Products
              </v-stepper-step>
              <v-stepper-content class="ma-0 pa-0" step="1">
                <v-card-text>
                  <v-list class="list-350">
                    <template v-for="(row, index) in Invoice.InvoiceDetails">
                      <v-list-item :key="row.id">
                        <v-list-item-content>
                          <v-list-item-title>{{ row.name }}</v-list-item-title>
                          <v-list-item-subtitle>Refunded: {{ row.refundAmount | currency }},  Balance: {{ row.price-row.refundAmount | currency }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-text-field
                            type="number"
                            dense
                            outlined
                            class="right-input"
                            hide-details
                            @input="productAmountChanged"
                            label="Amount"
                            @focus="$event.target.select()"
                            v-model="row.amount"
                          ></v-text-field>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider
                        v-if="index + 1 < Invoice.InvoiceDetails.length"
                        :key="index"
                      >
                      </v-divider>
                    </template>
                  </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="refundProductDone" :disabled="productTotal <= 0" :loading="loading" color="primary" large>next {{ productTotal | currency }}</v-btn>
                </v-card-actions>
              </v-stepper-content>
              <v-stepper-step :complete="step > 2" step="2">
                Payments
              </v-stepper-step>
              <v-stepper-content class="ma-0 pa-0" step="2">
                <v-card-text>
                  <v-list class="list-350">
                    <template v-for="(row, index) in PaymentDetails">
                      <v-list-item :key="row.id">
                        <v-list-item-content>
                          <v-list-item-title>Payment # {{ row.id }}
                            <v-chip v-if="row.stripeChargeId" color="yellow" light small class="ml-2">Online</v-chip>
                            <v-chip v-if="row.Transaction && row.Transaction.status !== 'settled'" color="#D1C4E9" light small class="ml-2">Unsettled</v-chip>
                          </v-list-item-title>
                          <v-list-item-subtitle>Refunded: {{ row.refundAmount | currency }},  Balance: {{ row.amount-row.refundAmount | currency }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-text-field
                            type="number"
                            dense
                            outlined
                            class="right-input"
                            hide-details
                            @input="paymentAmountChanged"
                            label="Amount"
                            @focus="$event.target.select()"
                            v-model="row.price"
                          ></v-text-field>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider
                        v-if="index + 1 < PaymentDetails.length"
                        :key="index"
                      >
                      </v-divider>
                    </template>
                  </v-list>
                  <div class="text-center mt-3">
                    <span>Product Refund: {{ productTotal | currency }}/ Payment Refund:
                      {{ paymentTotal | currency }}/ Balance:
                      {{ productTotal-paymentTotal | currency }}</span>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn large text @click="step = step - 1">Back</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="submit()" :disabled="paymentTotal !== productTotal" :loading="loading" color="primary" large>refund {{ paymentTotal | currency }}</v-btn>
                </v-card-actions>
              </v-stepper-content>
            </v-stepper>
          </v-card>

        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import invoiceService from "@/modules/Invoice/service";
import paymentService from "@/modules/Payment/service.js";
import transactionService from "@/modules/Transaction/service.js";

export default {
  name: "refund-invoice",
  props: {
    refundDialog: {
      default: false,
    },
    invoiceId: {
      default: null,
    },
  },
  data() {
    return {
      Invoice: null,
      loading: false,
      dialog: false,
      productTotal: 0,
      PaymentDetails: [],
      step: 1,
      paymentTotal: 0,
    };
  },
  watch: {
    refundDialog(val) {
      this.dialog = val;
      if (val) {
        this.loadData();
      }
    },
  },
  methods: {
    productAmountChanged(){
      if(this.Invoice){
        this.productTotal = 0
        this.Invoice.InvoiceDetails.map((row) => {
          if(row.amount)
            this.productTotal += parseFloat(row.amount);
        });
      }
    },
    async loadData(){
      await this.loadInvoiceDetail();
      await this.loadPaymentDetail();
      await this.loadTransaction();
    },
    paymentAmountChanged(){
      this.paymentTotal = 0
      this.PaymentDetails.map((row) => {
        if(row.price)
          this.paymentTotal += parseFloat(row.price);
      });
    },
    loadInvoiceDetail() {
      this.loading = true;
      return invoiceService
        .getById(this.invoiceId, { invoice: true})
        .then(async (response) => {
          this.loading = false;
          this.Invoice = response.data;
          this.productTotal = 0
          let invoiceDetails = this.Invoice.InvoiceDetails
          this.Invoice.InvoiceDetails = []
          await invoiceDetails.map(detail => {
            if(detail.price >= 0){
              detail.amount = 0
              this.Invoice.InvoiceDetails.push(detail)
            }
          })
          return response;
        });
    },
    loadPaymentDetail() {
      this.loading = true;
      return paymentService
        .getAllPaymentDetail({ InvoiceId: this.invoiceId})
        .then(async (response) => {
          this.loading = false;
          let paymentDetails = response.data;
          await paymentDetails.map(detail => {
            if(detail.amount >= 0){
              detail.price = 0
              this.PaymentDetails.push(detail)
            }
          })
          return response;
        });
    },
    loadTransaction() {
      this.loading = true;
      let filteredIds = []
      this.PaymentDetails.map(row => {
        if(row.stripeChargeId){
          filteredIds.push(row.stripeChargeId)
        }
      })
      if (filteredIds.length) {
        return transactionService
          .getAll({filteredIds: filteredIds})
          .then((result) => {
            let transactions = result.data
            this.PaymentDetails.map(paymentDetail => {
              if(paymentDetail.stripeChargeId){
                const matchingTransaction = transactions.find(transaction => transaction.transactionId === parseInt(paymentDetail.stripeChargeId));
                if (matchingTransaction) {
                  paymentDetail.Transaction=matchingTransaction
                }
              }
            });
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.log("error", error);
          });
      }
    },
    refundProductDone(){
      this.paymentTotal = 0
      let amountGreater = false
      this.Invoice.InvoiceDetails.map(invoice => {
        if((invoice.price-invoice.refundAmount) < invoice.amount){
          amountGreater = true
          return true
        }
      })
      if(amountGreater){
        this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "error",
          title: "Row amount cannot be greater than row balance",
        });
        return true
      }
      if(this.productTotal > this.Invoice.payment){
        this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "error",
          title: `Refund of $${this.Invoice.payment} is allowed only`,
        });
        return true
      }
      this.PaymentDetails.map(detail => {
        detail.price = 0
      })
      this.step=2
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Invoice = null,
      this.productTotal = 0,
      this.loading = false,
      this.PaymentDetails = [],
      this.step = 1,
      this.paymentTotal = 0
    },
    submit() {
      if(this.paymentTotal > this.Invoice.payment){
        this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "error",
          title: `Refund of $${this.Invoice.payment} is allowed only`,
        });
        return true
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.Invoice.totalRefund = this.productTotal
          this.Invoice.PaymentDetails = this.PaymentDetails
          return invoiceService
            .refundInvoice(this.Invoice)
            .then((result) => {
              if (result.status) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                  })
                  .fire({
                    icon: "success",
                    title: "Invoice was refunded",
                  });
                this.loading = false;
                this.empty();
                this.$emit("submit");                
                this.$events.emit("paymentListEvent");
                this.$events.emit("customerProfileEvent");
                // this.$events.emit("invoiceListEvent");
                this.close();
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "error",
                  title: err.data.message,
                });
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>
